<template>
  <nav id="navbar" class="navbar navbar-expand-lg navbar-light">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarToggler">
      <ul class="nav navbar-nav">
        <li v-for="(link, index) in sitemap" :key="index" class="nav-item">
          <router-link :to="link.url" data-toggle="collapse" data-target=".navbar-collapse.show" :name="link.name" v-html="link.name" exact></router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'Navbar',
    components: {

    },
    data() {
      return {

      }
    },
    props: {
      sitemap: {
        type: Array
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/css/_variables.scss';

  .navbar {
    //box-shadow: 0 0 5px 0 #000;
    border-radius: 0.5em;
    border: 1px solid rgba(0,0,0,0.2);
    background-color: $bg_color2;
  }

  .navbar-nav a:hover {
    color: $font_color1 !important;
    cursor: pointer;
    background-color: rgba(255,255,255,0.2);
  }

  .navbar-brand:hover {
    font-weight: normal;
  }

  .nav-item {
    font-size: 1em;
    //margin-right: 10px;
  }

  .nav-item a {
      padding: 10px 20px;
  }

  .nav-item .router-link-active {
    color: $font_color2;
    background-color: rgba(0,0,0,0.2);
  }

  .navbar-toggler {
    border-color: $font_color2 !important;
  }

  .navbar-brand {
    padding-right: 20px;
  }

  @media screen and (max-width: 991px) {
    .navbar-nav, .nav-item {
      margin: 10px 0;
    }

    .navbar-brand {
      margin-left: 15px;
    }
  }
</style>
